import React, {useMemo} from 'react';

import {useDataTableSelection} from 'src/components/data-table-selection';
import {FUTURE_FEATURE_MESSAGE} from 'src/constants';

import {SelectionView} from '@pb/kit-component-selection';


import type {Error} from 'src/openapi/admin/models/Error';

type Props = {
    totalCount: number,
    entityIds: Array<number | string>,
    selectionKey: string,
    onSetSelection?: (ids: Array<number | string>) => void,
    maxSelected?: number,
    getEntityIds?: () => Promise<{
        type: string,
        payload: {
            data: number[] | string[],
            success: true,
            error: false,
        } | {
            data: Error,
            success: false,
            error: true,
        },
    }>,
};


export const SelectionHeader = (props: Props) => {
    const {totalCount, entityIds, selectionKey, onSetSelection, maxSelected, getEntityIds} = props;
    const {setSelection, selection} = useDataTableSelection({
        rows: entityIds,
        key: selectionKey,
        onSetSelection,
        getEntityIds,
    });

    const tooltip = useMemo(() => {
        if (!totalCount) {
            return 'No results to select';
        }

        if (!getEntityIds) {
            return FUTURE_FEATURE_MESSAGE;
        }

        if (maxSelected && totalCount > maxSelected) {
            return `${maxSelected} - maximum number of selected items.`;
        }

        return undefined;
    }, [getEntityIds, totalCount, maxSelected]);

    return (
        <div title={tooltip}>
            <SelectionView {...{
                disabled: !!tooltip,
                selection,
                setSelection,
                totalCount,
            }}
            />
        </div>
    );
};
